import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';
import { EagerMultiSelectDataSource } from '../../extension/multi-select/eager-multi-select-data-source';
import { userOptionActions } from '../state/user-option.actions';
import { userOptionSelectors } from '../state/user-option.reducer';

export class UserMultiSelectDataSource extends EagerMultiSelectDataSource<UserOption> {
   constructor(store: Store<AppState>, filterOverrides: string[]) {
      super(store, userOptionActions, userOptionSelectors);
      this.filterOverrides = filterOverrides;
   }

   compareWith(a: UserOption, b: UserOption): boolean {
      return a.userId === b.userId;
   }
}
